export default __webpack_public_path__ + "static/media/NIAS0480.34I-43129_-25791_0.14a1ba1a.jpg";